import { useEffect, useRef } from "react";

// events to listen for user activity
const events = ["mousemove", "keydown", "click"];

/** timeout in seconds */
export const useInactivityLogout = (onLogout: () => void, timeout = 10 * 60) => {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(onLogout, timeout * 1000);
    };

    useEffect(() => {
        const broadcastActivity = () => {
            const now = new Date().toISOString();
            localStorage.setItem("lastActivityTimestamp", now);
        };

        const handleStorageEvent = (event: StorageEvent) => {
            if (event.key === "lastActivityTimestamp") {
                resetTimer();
            }
        };

        const handleActivity = () => {
            broadcastActivity();
            resetTimer();
        };

        for (const event of events) {
            window.addEventListener(event, handleActivity);
        }
        window.addEventListener("storage", handleStorageEvent);

        // Initialize timer
        resetTimer();

        return () => {
            for (const event of events) {
                window.removeEventListener(event, handleActivity);
            }
            window.removeEventListener("storage", handleStorageEvent);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [onLogout, timeout]);
};
